import { toDate } from '@art-suite/art-core-ts';
import { apiDate, optionalString, string, uuid, zodLess, ZodLessInfer } from '@kaiizen/zod-less';
import { optionalApiDate, optionalMetadataSchema } from '../schemaLib';

export const ApiScanTemplateSchema = zodLess({
  id: uuid,
  createdAt: apiDate,
  updatedAt: apiDate,
  archivedAt: optionalApiDate,
  orgId: uuid,
  name: string,
  customerMetadata: optionalMetadataSchema,
  description: optionalString,
}, { ref: 'scanTemplate', description: 'Scan templates define the structure and requirements for property scans.' });

export const ApiCreateScanTemplateSchema = ApiScanTemplateSchema.omit({ id: true, createdAt: true, updatedAt: true, archivedAt: true, orgId: true });
export const ApiUpdateScanTemplateSchema = ApiCreateScanTemplateSchema.extend({ archivedAt: string.nullable().optional() }).partial();
export type ApiScanTemplate = ZodLessInfer<typeof ApiScanTemplateSchema>;
export type ApiCreateScanTemplate = ZodLessInfer<typeof ApiCreateScanTemplateSchema>;
export type ApiUpdateScanTemplate = ZodLessInfer<typeof ApiUpdateScanTemplateSchema>;
export const getScanTemplatesQueryKey = (archived?: boolean) => archived ? `scanTemplates/archived` : 'scanTemplates';
export const getScanTemplateQueryKey = (scanTemplateId?: string) => `scanTemplate/${scanTemplateId}`;
export const getScanTemplatePartHistoryQueryKey = (
  scanTemplateId: string | undefined,
  scanPartId: string | undefined,
  { from, to, limit }: { from?: Date; to?: Date; limit?: number } = {},
) =>
  `scanTemplatePartHistory/byScanTemplateId/${scanTemplateId ?? ''}/${scanPartId ?? ''}?from=${from?.toISOString() ?? ''}&to=${to?.toISOString() ?? ''}&limit=${
    limit ?? ''
  }`;

// Template versions are cached on devices indefinitely. Bump this when stored template versions are
// corrected in place, so every device refetches them once (v2: KAIDEV-4359 cost formula patch).
const SCAN_TEMPLATE_ROOT_CACHE_VERSION = 'v2';

export const getScanTemplateRootQueryKey = (scanTemplateId?: string, versionAt?: Date) =>
  `scanTemplateRoot/${SCAN_TEMPLATE_ROOT_CACHE_VERSION}/${scanTemplateId}${versionAt ? `?versionAt=${toDate(versionAt).toISOString()}` : ''}`;
